import { THUMBNAIL_SIZE } from '@enmon/commons/lib/enmon';
import type { DefaultTheme } from 'styled-components';

export enum SortOption {
  AlphabetAsc = 'AlphabetAsc',
  AlphabetDesc = 'AlphabetDesc',
  Oldest = 'Oldest',
  Newest = 'Newest',
  Type = 'Type',
}

export const isSortOption = (value: unknown): value is SortOption =>
  typeof value === 'string' && Object.values(SortOption).some(o => o === value);

export const FILE_ICON_CONFIG = {
  pdf: { iconString: 'pdfDocument', color: (theme: DefaultTheme) => theme.color.core.red.main[900] },
  xls: { iconString: 'excelDocument', color: (theme: DefaultTheme) => theme.color.core.green.main[900] },
  xlsx: { iconString: 'excelDocument', color: (theme: DefaultTheme) => theme.color.core.green.main[900] },
  csv: { iconString: 'excelDocument', color: (theme: DefaultTheme) => theme.color.core.green.main[900] },
  doc: { iconString: 'wordDocument', color: (theme: DefaultTheme) => theme.color.core.blue.main[700] },
  docx: { iconString: 'wordDocument', color: (theme: DefaultTheme) => theme.color.core.blue.main[700] },
  ppt: { iconString: 'powerPointDocument', color: (theme: DefaultTheme) => theme.color.core.red.main[900] },
  pptx: { iconString: 'powerPointDocument', color: (theme: DefaultTheme) => theme.color.core.red.main[900] },
  html: { iconString: 'HTMLFile', color: (theme: DefaultTheme) => theme.color.core.orange.main[700] },
  txt: { iconString: 'textDocument', color: (theme: DefaultTheme) => theme.color.core.gray.main[900] },
  '7z': { iconString: 'zipFile', color: (theme: DefaultTheme) => theme.color.core.yellow.main[700] },
  zip: { iconString: 'zipFile', color: (theme: DefaultTheme) => theme.color.core.yellow.main[700] },
  rar: { iconString: 'zipFile', color: (theme: DefaultTheme) => theme.color.core.yellow.main[700] },
  'tar.gz': { iconString: 'zipFile', color: (theme: DefaultTheme) => theme.color.core.yellow.main[700] },
} as const;

export const isFileType = (value: unknown): value is keyof typeof FILE_ICON_CONFIG =>
  typeof value === 'string' && Object.keys(FILE_ICON_CONFIG).some(o => o === value);

export const IMAGE_WIDTH = THUMBNAIL_SIZE;
export const IMAGE_HEIGHT = THUMBNAIL_SIZE;

export const FILE_ID_KEY = 'file.id' as const;
